export const urls = {
  summary: () => "/api/client/v1/dashboard/summary/",
};

export const keys = {
  all: () => ["dashboard-all"],
  summary: () => [...keys.all(), "summary"],
};
